var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlob2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sw-js-blob-svg",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sw-gradient",
    x1: 0,
    x2: 1,
    y1: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop1",
    stopColor: "rgba(248, 117, 55, 1)",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop2",
    stopColor: "rgba(251, 168, 31, 1)",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#sw-gradient)",
    d: "M13.5,-21.2C17.3,-21.1,20.2,-17.2,23.4,-13.1C26.6,-8.9,30.1,-4.5,26.8,-1.9C23.4,0.6,13.2,1.1,10.8,6.8C8.5,12.4,14,23.2,13.5,30.1C13,37,6.5,40.1,1.8,36.9C-2.8,33.7,-5.7,24.2,-12.7,21.1C-19.8,18,-31.1,21.2,-33.6,18.8C-36.1,16.3,-29.8,8.2,-24.3,3.2C-18.7,-1.7,-13.8,-3.5,-13.2,-9.2C-12.7,-15,-16.3,-24.9,-14.9,-26.3C-13.4,-27.8,-6.7,-20.8,-0.9,-19.2C4.8,-17.6,9.6,-21.3,13.5,-21.2Z",
    width: "100%",
    height: "100%",
    transform: "translate(50 50)",
    strokeWidth: 0,
    style: {
      transition: "all 0.3s ease 0s"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob2);
export default __webpack_public_path__ + "static/media/blob-2.e79fd07ac451703d56d2f57f9821f29e.svg";
export { ForwardRef as ReactComponent };